import {useState, useEffect, useMemo} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {usePreview} from '../contexts/StorefrontPreviewContext'

const useCustomFetch = (token, ids, isSlot = true) => {
    const [response, setResponse] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const {previewData = {}} = usePreview()

    const {app: appConfig} = getConfig()

    const slotParams = useMemo(
        () => (isSlot ? `c_contentSlotIDs=${ids}` : `c_contentAssetIDs=${ids}`),
        [ids, isSlot]
    )

    useEffect(() => {
        if (ids === null) return

        const fetchData = async () => {
            setLoading(true)
            setError(null)

            try {
                let fetchOptions = {}

                if (appConfig.storefrontApi.userName && appConfig.storefrontApi.password) {
                    fetchOptions = {
                        ...fetchOptions,
                        headers: {
                            Authorization:
                                'Basic ' +
                                btoa(
                                    `${appConfig.storefrontApi.userName}:${appConfig.storefrontApi.password}`
                                )
                        }
                    }
                }

                let host = ''
                let previewQueryString = ''
                let isPreview = false
                if (
                    window.location.href &&
                    window.location.href.includes('mobify-storefront.com')
                ) {
                    host = appConfig.commerceAPI.proxyPathOcapi
                    previewQueryString = Object.keys(previewData).length
                        ? '&' + new URLSearchParams(previewData).toString()
                        : ''
                    isPreview = true
                }
                const url = `${host}/getcustomcontent/?${slotParams}${previewQueryString}`
                const response = await fetch(url, fetchOptions)
                if (!response.ok) throw new Error('Failed to fetch preview content')
                const htmlRes = await response.text()
                if (isPreview) {
                    setResponse(
                        htmlRes.replace(
                            /href=(["'])https:\/\/(dev|staging)\.cavenders\.com/g,
                            'href=$1'
                        )
                    )
                } else {
                    setResponse(htmlRes)
                }
            } catch (err) {
                console.error('Error in fetching custom API:', err)
                setError(err.message || 'An unexpected error occurred')
            } finally {
                setLoading(false)
            }
        }

        fetchData()
    }, [slotParams, appConfig])

    return {response, loading, error}
}

export default useCustomFetch
